var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwoArrowsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.547853 2.21855L2.56036 0.206054L12.0479 9.69355L21.5354 0.206055L23.5479 2.21856L12.0479 13.7186L0.547853 2.21855ZM0.547853 14.3415L2.56036 12.329L12.0479 21.8165L21.5354 12.329L23.5479 14.3415L12.0479 25.8415L0.547853 14.3415Z",
    fill: "#006ad9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoArrowsDown);
export default __webpack_public_path__ + "static/media/twoArrowsDown.e217fa613d3e3a23a182c8d3b6b8ada5.svg";
export { ForwardRef as ReactComponent };